import { render, staticRenderFns } from "./AdminProjectsList.vue?vue&type=template&id=7b98f888&scoped=true&"
import script from "./AdminProjectsList.vue?vue&type=script&lang=js&"
export * from "./AdminProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98f888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
